module.exports = __webpack_public_path__ + "static/img/far2.82d23758.png";